import { render, staticRenderFns } from "./panel-create.vue?vue&type=template&id=392a0516"
import script from "./panel-create.vue?vue&type=script&lang=js"
export * from "./panel-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports